<script setup>
import fenixLogo from "@/assets/fenix-logo.png";

const props = defineProps({
  className: {
    type: String,
    default: "",
  },
  size: {
    type: String,
    default: "md",
    validator: (value) => ["sm", "md", "lg", "xl", "2xl"].includes(value),
  },
});

const sizeClasses = {
  sm: "h-10",
  md: "h-12",
  lg: "h-16",
  xl: "h-24",
  "2xl": "h-32",
};
</script>

<template>
  <a href="/" :class="['flex items-center', props.className]">
    <img 
      :src="fenixLogo" 
      alt="Fenix Guardian Monitor" 
      :class="[sizeClasses[props.size], 'w-auto object-contain']"
    />
  </a>
</template>
